<div class="sk-cms-carousel {{terminal}}"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
    {{if style.isShowTitle == '1'}}
         <% include('../common/title.art', {title: basic.title, terminal: terminalTitle}) %>
    {{/if}}

    {{if !content || content.length == 0}}
    <% include('../common/nodata.art') %>
    {{else}}
    <div class="carousel-main"
        {{if style.frame.type == 'custom'}}
            style="{{style.frame.width?('width:' + style.frame.width + 'px;'):''}}
                   {{style.frame.height?('height:' + style.frame.height + 'px;'):''}}"
        {{/if}}
    >
        <div class="swiper-container {{content.length > 1 ? 'sk-j-carousel' : ''}}"
             data-component-id={{id}}
             data-component-type={{type}}
             data-delay="{{style.showTime}}"
             data-speed={{style.carouselTime}}>
            <div class="swiper-wrapper">
                {{each content}}
                <div class="swiper-slide">
                    {{if $value.linkType != 'none' && !isDesign}}
                    <a target="_blank" href="{{$value.link}}" class="goto-link">
                    {{/if}}
                        {{if $value.ext == 'mp4' || $value.ext == 'mov' || $value.ext == 'mkv' || $value.ext == 'wmv'}}
                        <video src="{{$value.imgUrl}}" alt="" style="max-height: 100%; width: 100%;  vertical-align: bottom" controls controlsList="nodownload" {{style.videoPlay === '1' ? 'muted autoplay' : '' }}
                        poster="{{$value.imgUrl}}?x-oss-process=video/snapshot,t_200"></video>
                        {{else}}
                        <img src="{{$value.imgUrl}}" alt=""/>
                        {{/if}}
                    {{if $value.linkType != 'none' && !isDesign}}
                    </a>
                    {{/if}}
                </div>
                {{/each}}
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>

            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev lin-none"></div>
            <div class="swiper-button-next lin-none"></div>
        </div>
    </div>
    {{/if}}
</div>
